import {
  JsonFormsCellRendererRegistryEntry,
  JsonFormsRendererRegistryEntry,
} from '@jsonforms/core';
import { createDisplayControlRenderer } from './DisplayControlRenderer';
import { createLayoutRenderers } from './layouts';

export const combineDisplayRenderers = (
  dark?: boolean
): {
  cells: JsonFormsCellRendererRegistryEntry[];
  renderers: JsonFormsRendererRegistryEntry[];
} => {
  const layoutRenderers = createLayoutRenderers(dark);
  const controlRenderer = createDisplayControlRenderer(dark);

  return {
    cells: [],
    renderers: [...layoutRenderers, controlRenderer],
  };
};
